module.exports = __webpack_public_path__ + "img/dsci0015.a5533ee5.jpg";